(function ($) {
  'use strict';

  $('document').ready(function () {
    if (!$.fn.owlCarousel) {
      return;
    }

    var $owlEventNavigation = $('.event-registration-teaser .owl-carousel');

    $owlEventNavigation.each(function () {
      var items = $(this).data('items');

      var responsive = {
        0: {
          items: 1,
        },
        768: {
          items: 3,
        },
        1024: {
          items: 5,
        },
      };

      var startPosition = $(this).find('[data-start]').data('start');

      if (items < 4) {
        responsive[768].items = Math.ceil(items / 2);
        responsive[1024].items = items;
      }

      var owlConfig = {
        dots: false,
        nav: true,
        // startPosition: startPosition ? startPosition : 0,
        loop: false,
        navText: [
          '<svg class="left font-icon"><use xlink:href="#caret" href="#caret"></use></svg>',
          $owlEventNavigation.data('nextText') +
            ' <svg class="right font-icon"><use xlink:href="#caret" href="#caret"></use></svg>',
        ],
        responsive: responsive,
        startPosition: startPosition,
      };

      $(this).owlCarousel(owlConfig);
    });
  });
}).bind(window)(jQuery);
